import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { SetupState, StorageKeys } from '../../../api/constants';
import * as api from '../../../api/setupServices';
import { useErrorContext } from '../../../errorHandler/context/ErrorContext';
import { type ApiError, FatalError } from '../../../errorHandler/errors';
import { getPortalUrl } from '../../../utils/utils';
import { STEPS } from '../../constants';
import './SetupComplete.less';

const TRANSLATION_ROOT = `setup.${STEPS.SETUP_COMPLETE}.content`;

const SetupComplete = () => {
  const { emitError } = useErrorContext();

  const [imprUsername] = useState(() => sessionStorage.getItem(StorageKeys.IMPR_IDP_USERNAME));
  const [imprDomain] = useState(() => sessionStorage.getItem(StorageKeys.IMPR_IDP_DOMAIN));
  const [samlDomain] = useState(() => sessionStorage.getItem(StorageKeys.SAML_IDP_DOMAIN));

  const hasSaml = !!samlDomain;
  // Either signal is enough to show directory guidance. The username is only known on the
  // same-session submit path; on re-entry the domain alone is re-derived (ICP-2164).
  const hasImprDir = !!imprDomain || !!imprUsername;

  useEffect(() => {
    const setupState = sessionStorage.getItem(StorageKeys.TENANT_SETUP_STATE);
    console.log('[Setup Complete] Setup State: ', setupState);

    async function completeSetup() {
      try {
        await api.sendTenantSetupCompleteRequest(false);
        sessionStorage.setItem(StorageKeys.TENANT_SETUP_STATE, SetupState.COMPLETED);
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        // If the complete setup call fails, show a full page error.
        emitError(new FatalError(e as ApiError));
      }
    }

    if (setupState === SetupState.STARTED) {
      void completeSetup();
    }
  }, [emitError]);

  return (
    <>
      <p><strong className="semi-bold"><Trans i18nKey={`${TRANSLATION_ROOT}.description`} />:</strong></p>
      <ul>
        <li><Trans i18nKey={`${TRANSLATION_ROOT}.description-list-1`} /></li>
        <li><Trans i18nKey={`${TRANSLATION_ROOT}.description-list-2`} /></li>
        <li><Trans i18nKey={`${TRANSLATION_ROOT}.description-list-3`} /></li>
      </ul>
      <p>
        <span><Trans i18nKey={`${TRANSLATION_ROOT}.link-prefix`} />:{' '}</span>
        <strong>
          <a
            href={getPortalUrl()}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: 'bold' }}
          >
            {window.location.host}
          </a>
        </strong>
      </p>
      {hasSaml && (
        <section className="user-login-info">
          <strong className="semi-bold"><Trans i18nKey={`${TRANSLATION_ROOT}.saml-sign-in`} /></strong>
          <div><span className="text-secondary">[yourusername]</span><span>@</span><span>{samlDomain}</span></div>
        </section>
      )}
      {hasImprDir && (
        <section className="user-login-info">
          <strong className="semi-bold"><Trans i18nKey={`${TRANSLATION_ROOT}.impr-sign-in`} /></strong>
          {imprUsername && <div>{imprUsername}</div>}
          {imprUsername && imprDomain && <div><Trans i18nKey={`${TRANSLATION_ROOT}.or`} /></div>}
          {imprDomain && (
            <div><span className="text-secondary">[yourusername]</span><span>@</span><span>{imprDomain}</span></div>
          )}
        </section>
      )}
      <div className="close-text-wrapper">
        <strong className="close-text semi-bold"><Trans i18nKey={`${TRANSLATION_ROOT}.close`} /></strong>
      </div>
    </>
  );
};

export default SetupComplete;
